<template>
  <PanelAdmin />
</template>

<script>
import { defineComponent } from 'vue'

import PanelAdmin from '../components/PanelAdmin.vue'

export default defineComponent({
  name: 'PanelAdminView',

  components: {
    PanelAdmin
  }
})
</script>
